export default __webpack_public_path__ + "static/media/panda.a705425b.png";